import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiBaseUrl from "../apiBase";

// Initialize array to hold data returned from ProjectListData function
let projectData = [];

const getTextValue = (item, keys) => {
	for (const key of keys) {
		const value = item?.[key];
		if (value !== undefined && value !== null) {
			return String(value);
		}
	}
	return "";
};

const getProjectId = (project) => project?.ProjectID ?? project?.projectId;
const getProjectName = (project) =>
	getTextValue(project, ["ProjectName", "projectName"]);
const getSponsor = (project) => getTextValue(project, ["Sponsor", "sponsor"]);

// Retrieve data and sort as needed.
export function ProjectListData() {
	const [data, setData] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	//This code is an alternative to the code above.  It uses async/await instead of .then. It is a little more readable, but does the same thing. For bigger projects, it is recommended to use async/await.
	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const response = await fetch(`${apiBaseUrl}/LRTPProject/getall`);
				if (!response.ok) {
					throw new Error(`Error: ${response.statusText}`);
				}
				const data = await response.json();
				setData(data);
				setLoading(false);
			} catch (error) {
				setError(error);
			}
		};

		fetchData();
	}, []);

	if (loading) return <h1>Loading...</h1>;
	if (error) return <pre>{JSON.stringify(error)}</pre>;
	if (!data) return null;

	const sorted = [...data].sort((a, b) =>
		getProjectName(a).localeCompare(getProjectName(b)),
	);
	projectData = sorted;

	return (
		<div>
			<ProjectList />
		</div>
	);
}

const viewClick = (projectnumber) => {
	sessionStorage.setItem("ProjectNumber", projectnumber);
};

// main Accordion component
export const ProjectList = () => {
	ProjectListData();

	return (
		<div className="container">
			<div className="wrapper">
				<div className="answer-content">
					{projectData.map((project) => (
						<div
							className="answer-listitem"
							key={getProjectId(project) ?? getProjectName(project)}
						>
							<Link
								to="/projectsummary"
								className="project-link"
								onClick={() => viewClick(getProjectId(project))}
							>
								{getProjectName(project)}
							</Link>
							{getSponsor(project)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default ProjectList;
